
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/BlogPost'));
const CalculadoraPage = lazy(() => import('../pages/calculadora/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/PrivacyPolicy'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1E3A5F] mx-auto mb-4"></div>
      <p className="text-[#1E3A5F] font-medium">Carregando...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <HomePage />
      </Suspense>
    )
  },
  {
    path: '/blog',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <BlogPage />
      </Suspense>
    )
  },
  {
    path: '/blog/:slug',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <BlogPostPage />
      </Suspense>
    )
  },
  {
    path: '/calculadora',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CalculadoraPage />
      </Suspense>
    )
  },
  {
    path: '/privacy-policy',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <PrivacyPolicyPage />
      </Suspense>
    )
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <NotFoundPage />
      </Suspense>
    )
  }
];

export default routes;
